/* istanbul ignore file */
import { ServiceErrorGraphic } from '@econsult/econsult-ui/dist/assets';
import styled from 'styled-components';
import { Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';
import { FlexColumnDiv } from 'components/Div/styles';

export const PatientInfoWrapper = styled(FlexColumnDiv)`
  background: ${({ theme }) => theme.colorNeutralBrightWhite};
  border: 1px solid ${({ theme }) => theme.colorNeutralNeutral8};
  border-radius: 0.25rem;
  padding: 0.6rem 1rem;
  height: 50px;
  box-sizing: border-box;
  justify-content: center;
`;

export const FormPage = styled(PatientInfoWrapper)`
  height: auto;
  justify-content: space-between;
  gap: 1.5rem;
`;

export const MessageWrapper = styled(FormPage)`
  align-items: center;
  padding-top: 1.25rem;
`;

export const Graphic = styled(ServiceErrorGraphic)``;

export const Message = styled(Paragraph)`
  text-align: center;
  color: ${({ theme }) => theme.colorNeutralBlack};
  font-size: 14px;
  line-height: 1.2;
  font-weight: 400;
  margin: 0;
`;
